import { render, staticRenderFns } from "./ModattaStepInteractionUniqueCode.vue?vue&type=template&id=2f4881f2&scoped=true"
import script from "./ModattaStepInteractionUniqueCode.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionUniqueCode.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepInteractionUniqueCode.vue?vue&type=style&index=0&id=2f4881f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4881f2",
  null
  
)

export default component.exports